<template>
  <div class="ordenes-trabajo-usuarios">
    <b-card no-header>
      <b-row>
        <b-col cols="12">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="usuariosList" 
              :fields="usuariosFields">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>
            <template v-slot:cell(usuario)="data">
              {{ data.item.usuario.trim() + ' - ' + data.item.usuarioRol.trim() }}
            </template>
            <template v-slot:cell(asignado)="data">
              <b-form-checkbox
                  v-if="!data.item.asignadoPresupuesto"
                  v-model="data.item.asignado"
                  :value="Boolean(true)"
                  :unchecked-value="Boolean(false)">
              </b-form-checkbox> 
              <template v-if="data.item.asignadoPresupuesto">
                Asignado PI
              </template>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Grabar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="cancel">Cancelar</b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'ordenestrabajosusuarios/getField',
  mutationType: 'ordenestrabajosusuarios/updateField',
});

export default {
  name: 'UsuariosSeleccion',
  components: {
  },
  props: {
    presupuestoInternoId: {
      type: Number,
      default: 0
    },
    ordenTrabajoId: {
      type: Number,
      default: 0
    }
  },
  data: () => {
    return {
      usuariosFields: [
        {
          key: 'usuario',
          label: 'Usuarios',
          // sortable: true
        },
        {
          key: 'asignado',
          label: '',
          class: 'text-center'
          // sortable: true
        },
      ],
      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'usuariosList',
    ]),
  },
  created() {
    this.getItems();
  },  
  methods: {
    okAction(){
      if (this.modalOkAction) {
        this.modalOkAction();
      }
    },
    hiddenAction(){
      if (this.modalHiddenAction) {
        this.modalHiddenAction();
      }
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('ordenestrabajosusuarios/getUsuariosAsignar', this.ordenTrabajoId)
        .catch(error =>  {
          this.msjModalVisible= true;
          this.msjModal = error;
          this.modalOkAction = null;
          this.modalHiddenAction = null;
        })
        .finally(() => this.tableBusy = false);
    },
    save() {
      this.showSpinner();
      this.$store.dispatch('ordenestrabajosusuarios/setUsuariosOrden')
        .then(() => {
          this.$emit('close');
        })
        .finally(() => this.hideSpinner());
    },
    cancel() {
      this.$emit('close');
    }
  },
  watch: {
  }    
}
</script>

<style>
  .ordenes-trabajo-usuarios .table thead th {
    border-top: none;
  }
  /* .presupuestos-usuarios small {
    margin-bottom: 0px;
  } */
</style>
